<template>
	<div class="wrapper">
		<header class="site-header" :class="{scrolled}">
			   <div class="promo-banner">
					<p class="promo-full"><span> COMPLIMENTARY IN-HOME DESIGN CONSULTATION, </span>NO OBLIGATION</p>
					<p class="promo-short"><span>COMPLIMENTARY IN-HOME CONSULTATION</span></p>
				</div>
				<nav>
					<router-link to="/" class="logo" aria-label="K&amp;M Remodeling Services — Home">
						<img src="@/assets/logo3.svg" alt="K&amp;M Remodeling Services">
					</router-link>
					<div class="nav-right">
						<div class="link desktop-menu">
							<div class="links">
	                     <router-link to="/">Home</router-link>
								<router-link to="/services">Our Services</router-link>
								<router-link to="/our-portfolio">Portfolio</router-link>
								<!-- <router-link to="/investor-flip">Investor Flip</router-link> -->
								<!-- <router-link to="/contact">Contact Us</router-link> -->
							    <!-- <router-link to="/faq">FAQ</router-link> -->
								<a href="tel:+19808905255">Call Us: (980) 890-5255</a>
							</div>
						</div>
						<!-- Иконка бургера для мобильной версии -->
						<div class="burger-menu" :class="{ open: isMobileMenuOpen }" @click="toggleMobileMenu">
							<font-awesome-icon :icon="['fas', 'bars']" />
						</div>
						<div class="basket">
							<button @click="showPopup = true" class="open-btn"> Book a Consultation </button>
						</div>
					</div>
					<div :class="{ 'mobile-menu': true, 'active': isMobileMenuOpen }">
						<div class="burger-menu" :class="{ open: isMobileMenuOpen }" @click="toggleMobileMenu">
							<font-awesome-icon :icon="['fas', 'times']" />
						</div>
						<router-link to="/">Home</router-link>
						<router-link to="/services">Our Services</router-link>
						<router-link to="/our-portfolio">Portfolio</router-link>
						<router-link to="/investor-flip">Investor Flip</router-link>
						<router-link to="/contact">Contact Us</router-link>
						<router-link to="/faq">FAQ</router-link>
						<a href="tel:+19808905255" class="call">Call Us: (980) 890-5255</a>
						<div class="basket1">
						   <button @click="showPopup = true"> Book a Consultation </button>
					  </div>
					</div>
				</nav>
				<transition name="fade">
				<popap-view v-if="showPopup" @close="showPopup = false"/>
				</transition>
		</header>
		<div class="main">
			<div>
				<slot></slot>
			</div>
			<form-view/>
			<map-view/>
			<section class="footer">
				<div class="footer__content">
               <div class="footer__intro">
					<h2>Ready to start your remodel?</h2>
					<button type="button" class="footer__cta" @click="showPopup = true">Schedule Your Complimentary Consultation</button>
					<a href="mailto:sales@kmremodelingservices.com">
						<span class="link">
						   <img src="@/assets/mail.svg" alt="icon">
						   <p>sales@kmremodelingservices.com</p>
					   </span>
					</a>
					<p class="footer__area">Serving Ballantyne, SouthPark, Providence, Weddington, Marvin, Waxhaw, Matthews, Mint Hill, Monroe, Pineville, Harrisburg and surrounding areas.</p>
				   </div>
				   <div class="navigator">
					<div class="links">
                  <router-link to="/">Home</router-link>
						<router-link to="/services">Our Services</router-link>
						<router-link to="/our-portfolio">Portfolio</router-link>
						<router-link to="/investor-flip">Investor Flip</router-link>
						<router-link to="/contact">Contact Us</router-link>
					   <router-link to="/faq">FAQ</router-link>
					   <a href="tel:+19808905255">Call Us: (980) 890-5255</a>
				   </div>
					<div class="socials">
						<h3>Follow Us</h3>
						<div class="social">
							<a href="https://www.facebook.com/profile.php?id=61566339405086&locale=uk_UA" target="_blank" rel="noopener noreferrer">Facebook</a>
                            <a href="https://www.tiktok.com/@kmremodelingservices?_t=ZT-90uPjfUtn6t&_r=1" target="_blank" rel="noopener noreferrer">TikTok</a>
						    <a href="https://www.instagram.com/kmremodelingservices?igsh=ZmlrYWVjZW9qbGNj" target="_blank" rel="noopener noreferrer">Instagram</a>
							<a href="https://www.linkedin.com/company/k-m-remodeling-services/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
							<a href="https://www.youtube.com/@KMRemodelingServices/shorts" target="_blank" rel="noopener noreferrer">YouTube</a>
						</div>
					</div>
				   </div>
				</div>
				
				<div class="footer__bottom">
					<span class="text">© {{ currentYear }} K&amp;M Remodeling Services LLC. All rights reserved.</span>
					<span class="footer__sep" aria-hidden="true"> · </span>
					<span class="text__privacy"><router-link to="/privacy-policy">Privacy Policy</router-link></span>
				</div>
				<back-button/>
			</section>
		</div>
	</div>
</template>

<script> 
import BackButton from '@/components/BackButton.vue';
import FormView from '@/components/FormView.vue';
import PopapView from '@/components/PopapView.vue';
import MapView from '@/components/MapView.vue';


export default {
	name: 'MainMasterpage',
	components: { BackButton, FormView, PopapView, MapView },
	data() {
		return {
			isMobileMenuOpen: false,
			showPopup: false,
			scrolled: false,
		};
	},
	computed: {
		currentYear() {
			return new Date().getFullYear();
		}
	},
	methods: {
		toggleMobileMenu() {
			this.isMobileMenuOpen = !this.isMobileMenuOpen;
		},
		
   },
	mounted() {
		window.addEventListener('scroll', () => {
			this.scrolled = window.scrollY > 20;
		});
	},
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.site-header.scrolled {
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}
.site-header {
	transition: box-shadow 0.25s ease, background-color 0.25s ease;
   position: sticky;
   top: 0;
   z-index: 1005;
	background: rgba(255, 255, 255, 0.97);
	border-bottom-left-radius: 12px;
	border-bottom-right-radius: 12px;

	.promo-banner {
		background-color: rgb(0 0 0 / 81%);
		color: #fff;
		text-align: center;
		padding: 10px 0;
		font-size: 14px;
		font-weight: 700;
		line-height: 110%;
		text-transform: uppercase;
		letter-spacing: 1px;
		width: 100%;
		p{
			margin: 0;
				span{
					color: #d89e1c;
				}
			@media(max-width: 1090px) {
				font-size: 12px;
			}
			@media(max-width: 690px) {
				font-size: 10px;
			}
		}
		.promo-short {
			display: none;
			white-space: nowrap;
		}
		@media(max-width: 690px) {
			.promo-full {
				display: none;
			}
			.promo-short {
				display: block;
			}
		}
	}

   nav {
		max-width: 1400px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		min-height: 70px;
		padding: 0px 80px;
		.logo {
			display: flex;
			align-items: center;
			text-decoration: none;
			flex-shrink: 0;
			img {
				display: block;
				height: 44px;
				width: 75px;
			}
			@media(max-width: 1090px) {
				img {
					height: 38px;
					width: 45px;
				}
			}
		}
		.nav-right {
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1 1 auto;
			margin-left: 40px;
			@media(max-width: 1090px) {
				margin-left: 20px;
			}
		}
      .links{
			display: flex;
			flex-wrap: wrap;
			gap: 50px;
			@media(max-width: 1090px) {
				gap: 25px;
			}
		}
		a {
			font-weight: 500;
			color: #262626;
			font-size: 16px;
			text-decoration: none;
			line-height: 110%;
			&.router-link-exact-active {
				color: #ACA296;
			}
		}

	}

	@media (max-width:1190px){
		nav {
			padding: 0px 30px;
		}
	}
	button {
	   padding: 15px 40px;
		white-space: nowrap;
	   background-color: #d89e1c;
	   color: white;
	   font-size: 16px;
	   font-weight: 500;
	   border-radius: 100px;
	   border: none;
	   cursor: pointer;
	   transition: background-color 0.2s ease;
		&:hover{
				background-color: #bf8b18;
			}
   }
	.burger-menu {
		display: none;
	}
	/* Стили для мобильного меню */
	.mobile-menu {
		visibility: hidden;
		position: fixed;
		top: -100%;
		left: 0;
		width: 100%;
		background-color: whitesmoke;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
		z-index: 99;
		opacity: 0;
		transform: translateY(-100%);
	}

	.mobile-menu {
		transition: all 0.7s ease;
	}

	@media (max-width:690px) {

		.desktop-menu {
			display: none;
			/* Скрываем десктопное меню на мобильном устройстве */
		}

		.logo {
			img {
				height: 32px;
				width: 40px;
			}
		}

		.nav-right {
			margin-left: 12px;
		}

		.burger-menu {
			display: block;
			/* Показываем иконку бургера на мобильном устройстве */
			cursor: pointer;
			font-size: 20px;
		}

		.mobile-menu.active {
			visibility: visible;
			display: flex;
			flex-direction: column;
			gap: 40px;
			padding: 20px 10px 30px 10px;
			opacity: 1;
			top: 0;
			transform: translateY(0);
		}

		nav {
			justify-content: space-between;
			align-items: center;
			padding: 0px 10px;


			a {
				font-size: 22px;
				color: black;
			}
		}
		.basket1{
		   margin: 0 auto;
		}
		button {
	      padding: 10px 25px;
      }
      .call{
	      color: blue;
      }
	}
}

.main {
	display: flex;
	flex-direction: column;
	max-width: 1400px;
	margin: 0 auto;
	.footer{
		margin-top: 30px;
		padding: 30px 0 50px;
		&__content{
			display: flex;
			justify-content: space-between;
			@media(max-width:795px) {
				flex-direction: column;
				row-gap: 30px;
		   }
		}
		&__intro{
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			padding-left: 10px;
			min-width: 0;
		}
		&__cta{
			width: 100%;
			max-width: 420px;
			margin-bottom: 30px;
			padding: 15px clamp(18px, 5vw, 32px);
			background-color: #d89e1c;
			color: #fff;
			font-size: clamp(13px, 1.4vw, 15px);
			font-weight: 500;
			line-height: 1.3;
			text-align: center;
			border-radius: 100px;
			border: none;
			cursor: pointer;
			transition: background-color 0.2s ease, transform 0.15s ease;
			&:hover{
				background-color: #bf8b18;
			}
			&:active{
				transform: translateY(1px);
			}
			&:focus-visible{
				outline: 3px solid rgba(216, 158, 28, 0.5);
				outline-offset: 3px;
			}
			@media (max-width: 425px) {
				font-size: 13px;
				padding: 13px 18px;
			}
		}
		&__area{
			margin: 20px 0 0;
			max-width: 520px;
			font-size: 15px;
			line-height: 1.6;
			color: #555;
		}
		&__bottom{
			margin-top: 50px;
			padding-left: 10px;
			font-size: 14px;
			font-weight: 400;
			line-height: 1.4;
			color: rgba(25, 25, 25, 0.65);
		}
		.text__privacy a{
			color: rgba(25, 25, 25, 0.65);
			text-decoration: none;
			&.router-link-exact-active {
				color: #ACA296;
			}
		}

		h2{
			font-weight: 500;
			font-size: 42px;
			line-height: 1.1;
			color: #191919;
			margin: 0 0 30px;
			@media (max-width: 768px) { font-size: 28px; }
		}

		a{
			text-decoration: none;
			.link{
				display: inline-flex;
				align-items: center;
				gap: 5px;

				img{
					width: 28px;
					height: 28px;
				}

				p{
					font-weight: 500;
					font-size: 24px;
					color: #262626;
					line-height: 110%;
					overflow-wrap: anywhere;
					@media(max-width:795px) {
						font-size: 16px;
				   }
				}
			}
		}

		.navigator {
			margin-top: 50px;
			margin-right: 30px;
         display: flex;
         justify-content: flex-end;
         column-gap: 30px;
			@media(max-width:795px) {
				margin-right: 0px;
				margin-top: 10px;
				display: grid;
				grid-template-columns: 1fr 1fr;
				column-gap: 20px;
				align-items: start;
				padding: 0 15px;
		   }
			.links {
				display: flex;
				flex-direction: column;
				gap: 20px;
			}

			a {
				font-weight: 500;
				color: #262626;
				font-size: 16px;
				text-decoration: none;
				line-height: 110%;

				&.router-link-exact-active {
					color: #ACA296;
				}
			}

			.socials{
				display: flex;
				flex-direction: column;
				row-gap: 20px;
				h3{
					margin: 0px;
					color: #ACA296;
					font-size: 16px;
					font-weight: 500;
					line-height: 110%;
				}
				.social{
				   display: flex;
				   flex-direction: column;
					row-gap: 20px;
					a{
						color:rgba(25, 25, 25, 1);
						font-size: 16px;
						font-weight: 500;
						line-height: 110%;
					}
			   }
			}
		}
	}
	@media(max-width:795px) {
			.footer{
				margin-top: 0px;
				padding: 10px 0 90px;
				h2{
					margin-bottom: 20px;
					text-align: left;
			   }
				&__intro{
					padding: 0 15px;
				}
				&__cta{
					display: block;
					width: 100%;
					max-width: none;
					margin-bottom: 20px;
					text-align: center;
				}
				.navigator{
					.links,
					.socials,
					.socials .social{
						gap: 14px;
					}
					a{
						overflow-wrap: anywhere;
					}
				}
				&__bottom{
					margin-top: 40px;
					padding: 0 15px;
				}
				&__sep{
					display: none;
				}
				.text,
				.text__privacy{
					display: block;
				}
				.text__privacy{
					margin-top: 10px;
				}
			}
	}
}
</style>